import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution } from "@/lib/attribution";

/**
 * Captures UTM parameters, click ids and referrer on the first pageview
 * (and on any subsequent navigation with new marketing signals).
 * Mounted once at the app root.
 */
const AttributionTracker = () => {
  const { pathname, search } = useLocation();
  const lastKey = useRef<string>("");

  useEffect(() => {
    const key = pathname + search;
    if (lastKey.current === key) return;
    lastKey.current = key;
    captureAttribution();
  }, [pathname, search]);

  return null;
};

export default AttributionTracker;